import React from 'react'
import styled from 'styled-components'
import _ from 'lodash'
import { injectIntl, FormattedMessage } from 'react-intl'

import RadioButtonGroup from '../../molecules/RadioButtonGroup'
import Card from '../../atoms/Card'

const StyledCard = styled(Card)`
  height: 360px;
`

const StyledRadioButtonGroup = styled(RadioButtonGroup)`
  display: flex;
  flex-direction: column;
`

class ResearchMeasurementUnitsCard extends React.PureComponent {
  render() {
    let { items, intl, ...otherProps } = this.props

    return (
      <FormattedMessage
        id="survey.measurement_units.title"
      >
        {(text) => (
          <StyledCard title={ text }>
            <StyledRadioButtonGroup
              items={ _.map(items, (i) => ({
                name: intl.formatMessage({ id: i.name }),
                value: i.value
              })) }
              { ...otherProps }
            />
          </StyledCard>
        )}
      </FormattedMessage>
    )
  }
}


export default injectIntl(ResearchMeasurementUnitsCard)



// WEBPACK FOOTER //
// ./src/components/molecules/ResearchMeasurementUnitsCard/ResearchMeasurementUnitsCard.js